// import { Row, Col } from "antd";


// const documents = [
//   {
//     name: "Personal Financial Statement",
//     meta: "PDF · 2.4 MB · Uploaded Jan 7, 2026",
//   },
//   {
//     name: "Tax Return 2024",
//     meta: "PDF · 1.8 MB · Uploaded Jan 7, 2026",
//   },
//   {
//     name: "K-1 Form",
//     meta: "PDF · 892 KB · Uploaded Jan 7, 2026",
//   },
// ];

// export default function UploadedDocuments() {
//   return (
//     <Row justify="center">
//       <Col xs={24} sm={24} md={24} lg={24} xl={24}>
//         <div>
//           <div className="uploaded-header">Uploaded Documents</div>

//           <ul className="uploaded-list">
//             {documents.map((doc, index) => (
//               <li className="uploaded-item cardViewMain " key={index}>
//                 <div className="uploaded-left">
//                   <span className="file-icon">📄</span>
//                   <div className="uploaded-text">
//                     <div className="doc-name">{doc.name}</div>
//                     <div className="doc-meta">{doc.meta}</div>
//                   </div>
//                 </div>

//                 <button className="view-btn">View</button>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </Col>
//     </Row>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message } from "antd";
// import { ArrowRightOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, ExpandOutlined, EyeOutlined } from "@ant-design/icons";
// import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css";
// import _consumerService from "../../../modules/consumerService";
// import { APP_BLOB_ROOT } from "../../../constants/constants";
// import _commonService from "../../../modules/commonService";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
// // import CommentSection from "../Administrator/CommentSection";
// import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from "../../../constants/constants";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { useHistory } from "react-router-dom";
// import { routes } from "../../../routes/Routes";
// const { Text, Title } = Typography;
// const { confirm } = Modal;

// const ApplicationDetailsTabForConsumer = ({ activeKey }) => {
//   const history = useHistory();
//   const [applicantDetails, setApplicantDetails] = useState({});
//   const [loading, setLoading] = useState(false);

//   let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");

//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedDocUrl, setSelectedDocUrl] = useState('');
//   const [selectedDocName, setSelectedDocName] = useState('');

//   useEffect(() => {
//     if (activeKey && activeKey == "3") {
//       getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
//     }
//   }, [activeKey]);

//   const getApplicantDetailsByID = async (applicationObjId) => {
//     setLoading(true);
//     try {
//       const res = await _consumerService.getConsumerInformationByConsumerId(applicationObjId);
//       if (res.data) {
//         let resObj = res?.data;
//         setApplicantDetails(resObj);
//         localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(true));
//         setLoading(false);
//       }
//     } catch (e) {
//       console.log(e);
//       setLoading(false);
//     }
//   };

//   const onDocumentEyeClick = (item) => {
//     setSelectedDocName(item.name);
//     setSelectedDocUrl(item.url);
//     setIsModalVisible(true);
//   };

//   const onDocumentDownloadClick = (item) => {

//     if (item === "Personal Financial Statement") {
//       if (applicantDetails?.Cons_PFS) {
//         setLoading(true);
//         //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Personal_FinStatement_Path;
//         const fileUrl = applicantDetails.Cons_PFS;
//         const fileName = applicantDetails.Cons_PFS.split("/").pop();

//         const link = document.createElement("a");
//         link.href = fileUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         setLoading(false);
//       }
//     } else if (item === "First 2 Pages of Federal Tax Return") {
//       if (applicantDetails?.Cons_FederalTax) {
//         setLoading(true);
//         //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc1_Patriot_Act_Form_Applicant_Path;
//         const fileUrl = applicantDetails.Cons_FederalTax;
//         const fileName = applicantDetails.Cons_FederalTax.split("/").pop();

//         const link = document.createElement("a");
//         link.href = fileUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         setLoading(false);
//       }
//     } else if (item == "K-1s") {
//       if (applicantDetails?.Cons_K1s) {
//         setLoading(true);
//         //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc2_Patriot_Act_Form_CoBorrower_Path_2;
//         const fileUrl = applicantDetails.Cons_K1s;
//         const fileName = applicantDetails.Cons_K1s.split("/").pop();

//         const link = document.createElement("a");
//         link.href = fileUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         setLoading(false);
//       }
//     } else if (item === "Fund Statements or Private Stock Evidence") {
//       if (applicantDetails?.Cons_FundStatement) {
//         setLoading(true);
//         //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc_Credit_Breau_Report_Path;
//         const fileUrl = applicantDetails.Cons_FundStatement;
//         const fileName = applicantDetails.Cons_FundStatement.split("/").pop();

//         const link = document.createElement("a");
//         link.href = fileUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         setLoading(false);
//       }
//     } else if (item == "Credit Bureau Report") {
//       if (applicantDetails?.Cons_CreditReport) {
//         setLoading(true);
//         //const fileUrl = APP_BLOB_ROOT + applicantDetails.UpDoc3_Credit_Bureau_Report_CBR;
//         const fileUrl = applicantDetails.Cons_CreditReport;
//         const fileName = applicantDetails.Cons_CreditReport.split("/").pop();

//         const link = document.createElement("a");
//         link.href = fileUrl;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         setLoading(false);
//       }
//     } else {
//       console.error("Unknown document type:", item);
//     }
//   };

//   const deleteDocument = (item) => {
//     confirm({
//       title: `Are you sure, want to delete this ${item.name}?`,
//       icon: <ExclamationCircleOutlined />,
//       okText: <span id="yesBtn">Yes</span>,
//       cancelText: <span id="noBtn">No</span>,
//       okType: "primary",
//       onOk() {
//         deleteDocumentObj(item.name);
//       }
//     });
//   };

//   const deleteDocumentObj = async (item) => {
//     console.log("item", item);
//     setLoading(true);
//     let documentType = "";
//     if (item === "Personal Financial Statement") {
//       documentType = "levconspfs";
//     } else if (item === "First 2 Pages of Federal Tax Return") {
//       documentType = "levconsfederaltax";
//     } else if (item === "K-1s") {
//       documentType = "levconsk1s";
//     } else if (item === "Fund Statements or Private Stock Evidence") {
//       documentType = "levconsfundstatement";
//     } else if (item === "Credit Bureau Report") {
//       documentType = "levconscreditreport";
//     } else {
//       console.error("Unknown document type:", item);
//     }

//     try {
//       const res = await _consumerService.deleteDocumentDataByApplicationId(localStorage.getItem("ApplicationObjId"), documentType);
//       if (res.data.IsSuccess) {
//         setLoading(false);
//         message.success(res.data.Message ? res.data.Message : RECORD_DELETED_MSG);
//         getApplicantDetailsByID(localStorage.getItem("ApplicationObjId"));
//       } else {
//         setLoading(false);
//         message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
//       }
//     } catch (e) {
//       setLoading(false);
//       console.log(e);
//     }
//   };

// const onDocumentsEditClick = () => {
//   localStorage.setItem("IsFromApplicationStatusTab", false);
//   history.push({
//     pathname: routes.documentsUpload.path,
//     state: { applicationObjId: localStorage.getItem("ApplicationObjId"), activeKey },
//   });
// }

//   const onEditApplicantIdentClick = () => {
//     localStorage.setItem("IsFromApplicationStatusTab", false);
//     history.push({
//       pathname: routes.newLiquidityApplication.path,
//       state: { applicationObjId: localStorage.getItem("ApplicationObjId"), activeKey },
//     });
//   }

//   const documentMap = {
//     "Personal Financial Statement": applicantDetails?.Cons_PFS,
//     "First 2 Pages of Federal Tax Return": applicantDetails?.Cons_FederalTax,
//     "K-1s": applicantDetails?.Cons_K1s,
//     "Fund Statements or Private Stock Evidence": applicantDetails?.Cons_FundStatement,
//     "Credit Bureau Report": applicantDetails?.Cons_CreditReport,
//   };

//   const documents = Object.entries(documentMap)
//     .filter(([_, path]) => !!path)
//     .map(([name, path]) => ({ name, url: path }));


//   console.log("A++", selectedDocUrl)

//   return (
//     <Spin spinning={loading}>

//       {documents && documents.length > 0 && (

//         <Card
//           style={{ borderRadius: 16 }}
//           bodyStyle={{ padding: 0 }}
//           className="mb30 cardViewMain"
//           title={
//             <Row justify="space-between" align="middle">
//               <Text strong>
//                 <span role="img" aria-label="user" style={{ marginRight: 8 }}>🧾</span>
//                 Documents
//               </Text>
//               <EditOutlined onClick={onDocumentsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
//             </Row>
//           }
//         >
//           {/* List */}
//           <div className="alignment-padding ">
//             <List
//               dataSource={documents}
//               renderItem={(item, index) => (
//                 <List.Item
//                   style={{
//                     padding: "12px 24px",
//                     // backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
//                     borderBottom: index === documents.length - 1 ? "none" : "1px solid #2e2f30",
//                   }}
//                   actions={[
//                     // <Button icon={<EyeOutlined />} type="text" key="view" onClick={() => onDocumentEyeClick(item)} />,
//                     <Button className="iconColor" icon={<DownloadOutlined />} type="text" key="download" onClick={() => onDocumentDownloadClick(item.name)} />,
//                     // <Button
//                     //   // disabled={["1", "5"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
//                     //   icon={<DeleteOutlined />}
//                     //   type="text" danger key="delete" onClick={() => deleteDocument(item)}
//                     // />,

//                     ...(["1", "6"].includes(localStorage.getItem("ApplicationStatusId"))
//                       ? [
//                         // <Button
//                         //   className="iconColor"
//                         //   icon={<DeleteOutlined />}
//                         //   type="text"
//                         //   key="delete"
//                         //   onClick={() => deleteDocument(item)}
//                         // />
//                       ]
//                       : []
//                     )
//                   ]}
//                 >
//                   <Space size="middle">
//                     <Text strong style={{ width: 24 }}>{`0${index + 1}.`}</Text>
//                     <Text>{item.name}</Text>

//                   </Space>
//                 </List.Item>
//               )}
//             />
//             {/* <Divider />
//             <Col span={8}>
//               <Text type="secondary" >CBR Score:</Text> <br />
//               <Text className="b-bottm">{applicantDetails && applicantDetails.CBRScore}</Text>
//             </Col> */}
//           </div>
//           {/* <CommentSection CommentSectionName="personalfinancialstatement" applicationstatusid={applicantDetails.Application_Status_Id} /> */}
//         </Card>
//       )}
//       <Modal
//         open={isModalVisible}
//         title={selectedDocName}
//         onCancel={() => setIsModalVisible(false)}
//         footer={null}
//         width="70vw" // Wider
//         bodyStyle={{ height: '70vh', padding: 0 }} // Taller
//         destroyOnClose
//       >
//         <iframe
//           src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDocUrl)}&embedded=true`}
//           width="100%"
//           height="100%"
//           style={{ border: "none" }}
//           title={selectedDocName}
//         />
//       </Modal>
//     </Spin>
//   )
// }
// export default ApplicationDetailsTabForConsumer;

import React, { useEffect, useState } from "react";
import { Card, List, Typography, Spin, Modal, Row } from "antd";
import { FileTextOutlined, EditOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import _consumerService from "../../../modules/consumerService";
import { routes } from "../../../routes/Routes";
import { useHistory } from "react-router-dom";


const { Text, Link } = Typography;

const UploadedDocuments = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const history = useHistory();



  /* ================= API ================= */
  useEffect(() => {
    if (activeKey && activeKey === "3") {
      getConsumerReportByConsumerId(localStorage.getItem("ApplicationObjId"));
    }
  }, [activeKey]);

  const getConsumerReportByConsumerId = async (ApplicationObjId) => {
    try {
      setLoading(true);
      const res = await _consumerService.getConsumerReportByConsumerId(ApplicationObjId);
      
      if (res.data) {
        const list = res?.data?.listApplicantDocs || [];
        setDocuments(
          list.map((doc) => ({
            name: doc.DocName,
            url: doc.DocPath,
            type: doc.DocType.replace(".", "").toUpperCase(),
            size: doc.DocSize,
            uploadedOn: dayjs(doc.DocCreatedDate).format("MMM D, YYYY"),
          }))
        );
        localStorage.setItem("IsFromConsumerDashboard", JSON.stringify(true));
      }

    } finally {
      setLoading(false);
    }
  };

  /* ================= VIEW ================= */
  const handleView = (doc) => {
    setSelectedDoc(doc);
    setOpen(true);
  };

  const onDocumentsEditClick = () => {
    localStorage.setItem("IsFromApplicationStatusTab", false);
    history.push({
      pathname: routes.documentsUpload.path,
      state: { applicationObjId: localStorage.getItem("ApplicationObjId"), activeKey },
    });
  }

  return (
    <Spin spinning={loading}>
      <Card
        className="uploaded-documents-card margin5px"
        title={
          <Row justify="space-between" align="middle">
            <div className="card-title">
              <FileTextOutlined />
              <span>Uploaded Documents</span>
            </div>
            <EditOutlined onClick={onDocumentsEditClick} style={{ color: "#595959", cursor: "pointer" }} />
          </Row>
        }

      >
        <List
          dataSource={documents}
          split={false}
          renderItem={(doc) => (
            <div className="document-row">
              <div className="document-left">
                <FileTextOutlined className="doc-icon" />

                <div>
                  <span className="doc-name">{doc.name}</span>
                  <div className="doc-meta">
                    {/* {doc.type} • {doc.size} • Uploaded {doc.uploadedOn} */}
                    {doc.type} • Uploaded {doc.uploadedOn}

                  </div>
                </div>
              </div>

              <span
                className="view-link"
                onClick={() => handleView(doc)}
              >
                View
              </span>
            </div>
          )}
        />
      </Card>

      {/* ========== PREVIEW MODAL ========== */}
      <Modal
        open={open}
        title={selectedDoc?.name}
        footer={null}
        width="70vw"
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        {selectedDoc && selectedDoc.type === "PDF" && (
          <iframe
            src={`https://docs.google.com/gview?url=${encodeURIComponent(
              selectedDoc.url
            )}&embedded=true`}
            style={{ width: "100%", height: "70vh", border: "none" }}
            title="pdf"
          />
        )}

        {selectedDoc && selectedDoc.type === "XLSX" && (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              selectedDoc.url
            )}&footer=false`}
            style={{ width: "100%", height: "70vh", border: "none" }}
            title="excel"
          />
        )}
      </Modal>
    </Spin>
  );
};

export default UploadedDocuments;
